import { z } from "zod";
import { BaseConfigurationsOutputItemSchema } from "@/Schemas/Configurations/BaseConfigurationsOutputItem";

export const ConfigurationsTypeOutputItemSchema = BaseConfigurationsOutputItemSchema.extend({
    description: z.string(),
    icon: z.string(),
});

export type ConfigurationsTypeOutputItem = z.infer<typeof ConfigurationsTypeOutputItemSchema>;

export const ConfigurationsTypeOutputSchema = z.object({
    items: z.array(ConfigurationsTypeOutputItemSchema),
});

export type ConfigurationsTypeOutput = z.infer<typeof ConfigurationsTypeOutputSchema>;